/* eslint-disable no-underscore-dangle */
const _ = require('lodash');

function validate(config) {
  if (_.isNil(config)) {
    throw new Error('config must not be null or undefined.');
  }
}

module.exports = class Rule {
  /**
   * See parent for details.
   * @param  {Object[]} config The configuration to build with.
   */
  constructor(config) {
    validate(config);

    this._name = config.name;
    this._evaluateState = false;
    this.active = false;

    this._ruleComponents = config.ruleComponents;
    this._inactiveComponents = [];
    this._calculatedValues = [];
    this._incompleteCalculations = [];
    this._violatedExceptions = [];
  }

  get ruleComponents() {
    return this._ruleComponents;
  }

  get name() {
    return this._name;
  }

  get evaluateState() {
    return this._evaluateState;
  }

  get incompleteCalculations() {
    return this._incompleteCalculations;
  }

  get calculatedValues() {
    return this._calculatedValues;
  }

  get violatedExceptions() {
    return this._violatedExceptions;
  }

  /**
   * Evaluates the current rule component based on the provided attributeSelection.
   *
   * @param  {Object} attributeSelection The attribute selection to evaluate.
   * @return {boolean} true if and only if this attribute is valid through the evaluation of attributeSelection.
   */
  evaluate(attributeSelection) {
    this._inactiveComponents = [];
    const results = _.map(this._ruleComponents, (component) => {
      const result = component.evaluate(attributeSelection);
      if (!result.evaluateState) {
        this._inactiveComponents.push(component);
      }
      return result;
    });

    if (_.isEmpty(this._inactiveComponents)) {
      this.active = false;
      this._evaluateState = true;
    }

    if (this._inactiveComponents.length === 1) {
      this.active = true;
    }

    if (!_.some(results, result => result.shouldCalculationsBeExcluded())) {
      _.each(results, (result) => {
        const formulaEvaluationResults = _.filter(
          result.componentEvaluationResults,
          evaluationResult => !_.isUndefined(evaluationResult.formula),
        );

        _.each(formulaEvaluationResults, (formulaResult) => {
          if (!formulaResult.result) {
            if (_.isUndefined(formulaResult.exception)) {
              this._incompleteCalculations.push({ key: formulaResult.key, formula: formulaResult.formula.expression });
            } else {
              this._calculatedValues.push({ key: formulaResult.key, exception: formulaResult.exception });
              this.active = false;
            }
          } else if (formulaResult.result && this.active) {
            this._calculatedValues.push({
              key: formulaResult.key,
              formula: formulaResult.formula.expression,
              value: formulaResult.formula.value,
            });
          }
        });
      });
    }

    return _.isEmpty(this._inactiveComponents);
  }
};
